class LoyaltyRewardsAll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    if (!this.els.slide || this.els.slide.elements.length < 1) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    this.els.navButton?.elements.forEach(el => {
      el.addEventListener('click', this.navButtonClick.bind(this))
    })
  }

  navButtonClick (e) {
    // Deselect all navigation buttons
    this.els.navButton.elements.forEach(el => el.removeAttribute('aria-selected'))
    e.target.setAttribute('aria-selected', true)

    // Set aria-active to false on all slides
    this.els.slide.elements.forEach(el => el.setAttribute('aria-active', false))

    // Get the selected level from the clicked button
    const selectedOption = e.target.dataset.option?.toLowerCase() || ''

    // Iterate through slides and set aria-active to true for slides NOT containing the selected level
    this.els.slide.elements.forEach(el => {
      const slideOptions = (el.dataset.option?.toLowerCase() || '').split(',')

      // Set aria-active to true if the selected level is NOT in the slide's options
      if (!slideOptions.some(option => option.trim() === selectedOption)) {
        el.setAttribute('aria-active', true)
      }
    })

    // smoothscroll back to first slide
    this.updateLevelLabel(selectedOption)
    this.updateLevelItem(selectedOption)
    this.updateTextItem(selectedOption)

    this.setupCheck()
  }

  setupCheck () {
    const hasCarousel = this.carousel != null

    if (hasCarousel) {
      this.carousel.destroy()
      this.carousel = null
    }

    this.carousel = this.setupCarousel()
  }

  updateLevelLabel (selectedOption) {
    this.els.level.elements.forEach(el => {
      const dataAttribute = `level${selectedOption.slice(-2)}`
      if (el.hasAttribute(`data-${dataAttribute}`)) {
        el.setAttribute('aria-hidden', 'false')
      } else {
        el.setAttribute('aria-hidden', 'true')
      }
    })
  }

  updateLevelItem (selectedOption) {
    this.els.slide.elements.forEach(el => {
      const dataAttribute = `level${selectedOption.slice(-2)}`
      if (el.hasAttribute(`data-${dataAttribute}`)) {
        el.removeAttribute('aria-hidden')
      } else {
        el.setAttribute('aria-hidden', 'true')
      }
    })
  }

  updateTextItem (selectedOption) {
    this.els.text.elements.forEach(el => {
      if (el.hasAttribute(`data-${selectedOption}`)) {
        el.removeAttribute('aria-hidden')
      } else {
        el.setAttribute('aria-hidden', 'true')
      }
    })
  }

  setupCarousel () {
    const slideElements = Array.from(this.els.slide.elements).sort((a, b) => {
      // Parse data-option into arrays of levels
      const aOptions = (a.dataset.option?.toLowerCase() || '').split(',').sort()
      const bOptions = (b.dataset.option?.toLowerCase() || '').split(',').sort()

      // Compare each level in the arrays
      for (let i = 0; i < Math.max(aOptions.length, bOptions.length); i++) {
        const aLevel = aOptions[i] || ''
        const bLevel = bOptions[i] || ''

        const comparison = aLevel.localeCompare(bLevel)
        if (comparison !== 0) return comparison
      }

      // If all levels are the same, maintain original order
      return 0
    })

    this.els.slides.element.innerHTML = ''
    slideElements.forEach(
      el => this.els.slides.element.appendChild(el),
    )

    this.els.slides.element.classList.add('keen-slider')
    slideElements.forEach(
      el => el.classList.add('keen-slider__slide'),
    )

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: '.loy-CustomerRewardsAll_Item:not([aria-hidden="true"])',
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.25,
        },
        breakpoints: {
          '(min-width: 700px)': {
            slides: {
              perView: 2.7,
            },
          },
          '(min-width: 1000px)': {
            slides: {
              perView: 4.2,
            },
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('loyalty-customer-rewards-all')) {
  customElements.define('loyalty-customer-rewards-all', LoyaltyRewardsAll)
}
